exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tabs--pill .v-tab,.v-tabs--pill .v-tab:before{border-radius:24px}.v-tabs--pill.v-tabs--icons-and-text .v-tab,.v-tabs--pill.v-tabs--icons-and-text .v-tab:before{border-radius:4px}", ""]);

// exports
